<template>
  <div class="pageJFTRecharge">
    <XR-head titleText="JKT充值" :rightShow="false"></XR-head>    
    <div class="total account-address">
      <p class="title">充值需知：</p>
      <p class="desc">如有充值问题，请联系：{{siteConfigInfo.Phone}}或QQ：{{siteConfigInfo.QQ}}。</p>
      <p class="tip">请打开资产钱包商城充值页面，给以下地址充值即可</p>
      <p class="address">{{UserInfo.Purse}}</p>
      <p class="copybtn" @click="copyText()">复制地址</p>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import siteconfig from '../../../../util/siteconfigCache'
export default {
  data() {
    return {
      siteConfigInfo: {},
      JFTInfo: {},
      UserInfo:{
        Purse:''
      }
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    this.siteConfigInfo = siteconfig.getSiteconfig()

    this.getUserInfo()
    this.getJFTInfo()
  },
  methods: {
    getUserInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(res.IsSuccess){        
          ths.UserInfo = res.Data;
        }
      });
    },
    getJFTInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/JftServer/GetJFTAccountInfo"
      ).then(function(res) {
        if(!res.IsSuccess){          
          if(res.TypeId == 1){
            ths.$router.push("/usercenter/JFTActive")
          }
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.JFTInfo = res.Data;
          ths.loaded=false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    copyText: function(){
    var oInput = document.createElement('input')
        oInput.value = this.UserInfo.Purse
        document.body.appendChild(oInput)
        oInput.select()
        document.execCommand("Copy")
        document.body.removeChild(oInput)
        this.$refs.XRtoast.success("复制成功", true)
    }
    
  }
};
</script>
<style>
#app .pageJFTRecharge{
  bottom: 0;
  background: white;
}
.pageJFTRecharge .total{
  background: white;
  padding: 20px 20px;
}
.pageJFTRecharge .title{
  line-height: 24px;
  font-size: 14px;
  color:red;
}
.pageJFTRecharge .account-address .desc{    
  padding: 10px 0 0;
  font-size: 12px;
  color:#999;
}
.pageJFTRecharge .account-address .tip{    
  padding: 10px 0 0;
  font-size: 12px;
  padding: 30px 0 0;
}
.pageJFTRecharge .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
}
.pageJFTRecharge .account-address{
  margin-bottom: 10px;
}
.pageJFTRecharge .account-address .address {
  font-size:12px;
  color:black;
  background:#efefef;
  margin: 20px 0;
  height:50px;
  line-height:50px;
  text-align: center;
}
.pageJFTRecharge .account-address .copybtn{
  text-align: center;
  font-size: 12px;
  color:Red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/jft/local/jftRecharge.vue